module.exports = __webpack_public_path__ + "img/suppliers.0c5d4e79.svg";